'use strict';

(function () {
	angular.module('onboarding.services')
		.factory('spinnerService', spinnerService);

	var subjectObserverMessagesService,
		observerService;

	spinnerService.$inject = ['subjectObserverMessagesService', 'observerService'];

	function spinnerService(_subjectObserverMessagesService_, _observerService_) {
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;

		return {
			startSpinner: startSpinner,
			stopSpinner: stopSpinner
		};

		function startSpinner(targetScope) {
			setTimeout(function () {
				observerService.sendMessageToSubject(targetScope,
					subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
			}, 1);
		}

		function stopSpinner(targetScope) {
			observerService.sendMessageToSubject(targetScope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
		}
	}
})();
